export const emailPattern = '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,7}$';
export const passwordPattern = '\\S{6,}';
export const websitePatter = '^(https?:\\/\\/)[\\w\\d][\\w\\.\\-_]*(?:\\.[\\w\\.\\-_]+)+[\\w\\-\\._~:\\/\\?#[\\]@!' +
  '\\$&’\\(\\)\\*\\+,;=\\.]+$';
export const phonePattern = '((\\+(\\s*\\d){2})?\\s*[(\\\\-_]?(\\s*\\d){3}\\s*[)\\\\-_]?)?(\\s*[\\-_]?\\s*\\d){7}';
